module.exports = __webpack_public_path__ + "static/media/picks_of_the_week.d2a13835.svg";